import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "bwinPickStation"
const COOKIE_MAX_AGE = 60 * 60 * 24 * 400
const PRESS_DURATION_MS = 3000

export default class extends Controller {
  static targets = ["panel", "option", "input", "trigger"]

  connect() {
    this.refreshAssignment()
    this.syncInput()
  }

  disconnect() {
    this.clearPress()
  }

  inputTargetConnected() {
    this.syncInput()
  }

  pressStart(event) {
    if (event.pointerType === "mouse" && event.button !== 0) return

    event.preventDefault()
    this.clearPress()
    this.triggerTarget.classList.add("is-pressing")
    this.pressTimer = setTimeout(() => this.open(), PRESS_DURATION_MS)
  }

  pressEnd() {
    this.clearPress()
  }

  preventMenu(event) {
    event.preventDefault()
  }

  open() {
    this.clearPress()
    this.panelTarget.classList.remove("hidden")
    this.highlightCurrent()
  }

  close() {
    this.panelTarget.classList.add("hidden")
  }

  select(event) {
    const station = event.currentTarget.dataset.value
    const current = this.readStation()

    if (!station || station === current) {
      this.writeStation("")
    } else {
      this.writeStation(station)
    }

    this.syncInput()
    this.close()
  }

  syncInput() {
    if (!this.hasInputTarget) return
    this.inputTarget.value = this.readStation()
  }

  highlightCurrent() {
    const current = this.readStation()
    this.optionTargets.forEach((option) => {
      option.classList.toggle("active", option.dataset.value === current)
    })
  }

  refreshAssignment() {
    const station = this.readStation()
    if (station) this.writeStation(station)
  }

  readStation() {
    return localStorage.getItem(STORAGE_KEY) || this.readCookie() || ""
  }

  writeStation(station) {
    if (station) {
      localStorage.setItem(STORAGE_KEY, station)
      this.writeCookie(station)
    } else {
      localStorage.removeItem(STORAGE_KEY)
      this.writeCookie("")
    }
  }

  readCookie() {
    const prefix = `${STORAGE_KEY}=`
    const pair = document.cookie.split("; ").find((entry) => entry.startsWith(prefix))
    return pair ? decodeURIComponent(pair.slice(prefix.length)) : ""
  }

  writeCookie(value) {
    if (value) {
      document.cookie = `${STORAGE_KEY}=${encodeURIComponent(value)}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`
    } else {
      document.cookie = `${STORAGE_KEY}=; path=/; max-age=0; SameSite=Lax`
    }
  }

  clearPress() {
    if (this.pressTimer) {
      clearTimeout(this.pressTimer)
      this.pressTimer = null
    }
    if (this.hasTriggerTarget) {
      this.triggerTarget.classList.remove("is-pressing")
    }
  }
}
